export default __webpack_public_path__ + "static/media/7.e12cb4d7.svg";